import userDashboard from "views/customer/app/Dashboard";
import userAllDevices from "views/customer/app/AllDevices";
import userSingleDeviceTable from "views/customer/app/SingleDeviceTable";




export { userDashboard, userAllDevices, userSingleDeviceTable };
